module.exports = __webpack_public_path__ + "img/cxr.aa81bb9e.svg";